import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import DeferredOrderDetailPage from './DeferredOrderDetailPage';
import './DeferredOrderDetailPage.less';

export const prefix = 'bm-p-deferred-order-detail';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: DeferredOrderDetailPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
